import { styled } from 'linaria/react';
import { media } from '../../../../../media';

export const StepsContainer = styled.div`
	display: block;
	width: 100%;
	height: max-content;
	overflow: hidden;
	border: 1px solid var(--control-minor);
	border-radius: 16px;

	& ol {
		padding: 24px 24px 40px;
		margin: 16px 0 0;
		list-style: none;
		& li {
			display: grid;
			align-items: start;
			grid-template-columns: 24px 1fr;
			margin-top: 16px;
			column-gap: 16px;
		}
		& li:first-child {
			margin-top: 0;
		}
	}
	${media.laptop} {
		& ol {
			padding: 24px 16px;
		}
	}
	${media.tablet} {
		& ol {
			padding: 16px 24px;
			margin-top: 8px;
		}
	}
`;

export const Header = styled.div`
	display: flex;
	flex-direction: row;
	align-items: end;
	justify-content: space-between;
	padding-left: 24px;
	& img {
		max-width: 112px;
	}
	${media.laptop} {
		padding-left: 16px;
	}
	${media.tablet} {
		align-items: center;
		padding-left: 24px;
	}
`;

export const StepNumber = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	color: var(--text-primary-invert);
	background-color: var(--control-primary);
	border-radius: 50%;
`;
